import styled from 'styled-components';
import Box from '@material-ui/core/Box';

const ToggleContainer = styled(Box)`
  svg {
    color: ${({ selected, theme }) => (selected ? theme.colors.SECONDARY_MAIN : theme.colors.PRIMARY_CONTRAST)} !important;
    opacity: ${({ selected }) => (selected ? 1 : 0.6)} !important;
  }
`;
const Styled = {
  ToggleContainer,
};

export default Styled;
